import _ from "lodash";
require('../../../bootstrap');

import Vue          from 'vue';
import ComponentSet from "../../../ComponentSet";
import utils        from "../../../Utils";
import Constants from "../../../Constants";

const components = _.merge(ComponentSet,
    {
        'Recent'     : () => import('./components/Recent.vue'     ),
        'Latest'     : () => import('./components/Latest.vue'     ),
        'Award'      : () => import('./components/Award.vue'      ),
        'Involvement': () => import('./components/Involvement.vue'),
    });

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: {
        latestNewsTotal:0,
        activityNewsTotal:0,
        recentUpdateTotal:0,
        awardsTotal:0,
        symposiumTotal:0,
    },
    created() {
        
    },
    beforeDestroy() {

    },
    mounted() {
        const _this = this
        // 取回該頁面需要用到的資料
        _this.retrieveSiteContentData();
        _this.fetchData(`${Constants.serverUrl}/api/about/news-count`, '', 'newsCount','pageData.contentData', function (extraParams, response) {

            _this.latestNewsTotal   = _.get(response, 'data.Value.pageData.contentData.latestNewsTotal'  , 0)
            _this.activityNewsTotal = _.get(response, 'data.Value.pageData.contentData.activityNewsTotal', 0)
            _this.recentUpdateTotal = _.get(response, 'data.Value.pageData.contentData.recentUpdateTotal', 0)
            _this.awardsTotal       = _.get(response, 'data.Value.pageData.contentData.awardsTotal'      , 0)
            _this.symposiumTotal    = _.get(response, 'data.Value.pageData.contentData.symposiumTotal'   , 0)
        })
    },
    methods: {
    }, // end of methods
    computed: {
    }, // end of computed
}).$mount('#app');